// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__sX35o","row":"App_row__oUpnO"};